exports.parse = require('./lib/parse');
exports.stringify = require('./lib/stringify');



//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/node_modules/css/index.js
// module id = 1164
// module chunks = 73